import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onClose: () => void;
}

const UploadSuccessModal = (props: Props) => {
  const { t } = useTranslation(["operation"]);

  return (
    <Mui.Dialog
      PaperProps={{
        sx: {
          maxWidth: "600px",
          minHeight: "214px",
        },
      }}
      open={props.open}
      aria-labelledby="draggable-dialog-title"
      maxWidth={"md"}
      onClose={props.onClose}
    >
      <Mui.DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        <Mui.Grid container alignItems="center" direction="row" spacing={2}>
          <Mui.Grid item sx={{ display: "flex" }}>
            <MuiIcons.CheckCircle sx={{ color: "green" }} />
          </Mui.Grid>

          <Mui.Grid xs item>
            <span>
              {t("eToll.uploadSuccessModal.title")}
            </span>
          </Mui.Grid>
          <Mui.Grid item sx={{ justifyContent: "flex-end", display: "flex" }}>
            <Mui.Button variant="text" size="icon">
              <MuiIcons.Close onClick={props.onClose} color="disabled" />
            </Mui.Button>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <Mui.DialogContent dividers>
        <Mui.Box>
          {t("eToll.uploadSuccessModal.body")}
        </Mui.Box>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Grid
          container
          alignItems="center"
          alignContent="center"
          direction="row"
        >
          <Mui.Grid>
            <Mui.Link href="/operation/vehicles/etollImport">
              {t("eToll.uploadSuccessModal.navigateMessage")}
            </Mui.Link>
          </Mui.Grid>
          <Mui.Grid
            xs
            item
            sx={{ display: "flex", justifyContent: "flex-end" }}
            pr={2}
          >
            <Mui.Stack direction="row" spacing={2.5}>
              <Mui.Button
                variant="contained"
                color="accent"
                onClick={props.onClose}
              >
                <Mui.Typography variant="h6" color="inherit">
                  {t("actionButtons.close")}
                </Mui.Typography>
              </Mui.Button>
            </Mui.Stack>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};
export default UploadSuccessModal;
